import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { PendingInteractionFormType } from '../@types/pendingInteraction.type';
import { getPendingInteractionsByServiceId } from '../api/pendingInteraction';
import { PendingInteractionKey } from '../configs/pendingInteraction';

export const useGetPendingInteractionsByServiceId = (serviceId: number): UseQueryResult<PendingInteractionFormType[]> => {
  return useQuery({
    queryKey: [PendingInteractionKey, serviceId],
    queryFn: () => getPendingInteractionsByServiceId(serviceId),
    enabled: serviceId > 0
  });
};